<template>
    <div>
        <div class="hiddenprint">
            <div id="removeConfirm" class="modal" :style="{width: (question.length + 6 ) +'ch', right: '40%'}">
                <div class="modal-content">
                    <p>{{question}}</p>
                </div>
                <div class="modal-footer">
                    <button class="modal-close btn-flat cancelbutton" v-on:click="cancelClicked()">{{cancelText}}</button>
                    <button class="modal-close waves-effect waves-light btn-small green" v-on:click="okClicked()">{{confirmText}}</button>
                </div>
            </div>
        </div>
        <div class="row hiddenprint" style="padding-left: 75px; padding-right: 75px; padding-top: 25px;">
            <div class="col s6 l8"><a class="btn green adder" v-if="edit==false && loaded" :href="'/interventions/'+intervention.id+'/v2.pdf'"><i class="material-icons left">print</i>{{$t('menu.buttons.print')}}</a></div>
            <div class="col s3 l2"><a class="waves-effect waves-light btn-large emptygreen" v-if="edit==false && intervention.editable" v-on:click="toggleEdit()">{{$t('menu.buttons.edit')}}</a></div>
            <div class="col s3 l2"><a class="waves-effect waves-light btn-large solidred" v-if="edit==false && intervention.removable" v-on:click="deleteProtocol()">{{$t('menu.buttons.delete')}}</a></div>
        </div>
        <div class="row" style="padding-left: 75px; padding-right: 75px; padding-top: 25px;" v-if="error">
            Wystąpił błąd w trakcie ładowania protokołu interwencyjnego.
        </div>
        <div class="interventionprotocol" v-if="loaded"  :editing="edit">
            <div class="row">
                <div class="col s12" style="text-align: center; font-size: x-large;">
                    {{$t('intervention.title')}}
                </div>
            </div>
            <div class="row">
                <div class="col s12" style="text-align: center; font-size: x-large; margin-bottom: 1em;">
                    {{$t('intervention.number')}} <b>{{intervention.number}}</b>
                </div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s1">{{$t('intervention.reporter')}}:</div>
                <div class="col s11">
                    <input :disabled="edit == false" v-model="intervention.originator_name" />
                </div>
            </div>
            <div class="row" v-if="!edit">
                <div class="col s1 offset-s6">{{$t('intervention.date')}}:</div>
                <div class="col s2"><b>{{intervention.date | formatDate}}</b></div>
                <div class="col s1">{{$t('intervention.hour')}}:</div>
                <div class="col s2"><b>{{intervention.date | formatHour}}</b></div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s2 label offset-s1" style="margin-bottom: 1em;">
                    <label>
                        <input :disabled="edit == false" type="checkbox" v-model="intervention.routine_service" />
                        <span>{{$t('intervention.select_place')}}</span>
                    </label>
                </div>
                <div class="col s1 label upper" v-if="intervention.routine_service">
                    {{$t('intervention.customer')}}:
                </div>
                <div class="col s3 label" v-if="intervention.routine_service">
                    {{placeById(intervention.place_id)}}
                </div>
                <div class="col s1 label upper" v-if="intervention.routine_service">
                    {{$t('intervention.place')}}:
                </div>
                <div class="col s4" v-if="intervention.routine_service && customers_loaded">
                    <selector :items="customerItems" :singlemode="true" v-model="intervention.place_id" groupitems='places' :disabled="edit == false" identifier="place">
                        </selector>
                </div>
            </div>
            <div class="row" v-if="!edit">
                <div class="col s2">{{$t('intervention.type')}}:</div>
                <div class="col s10" style="text-transform: uppercase;"><b>{{intervention.types | nameTypes(intervention.other_what)}}</b></div>
            </div>
            <div class="row" v-if="!edit">
                <div class="col s2" style="text-transform: uppercase;"><b>{{$t('intervention.reported_problem')}}:</b></div>
                <div class="col s10">{{intervention.about}}</div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s2 label leftalign" style="margin-bottom: 25px">
                    <b>{{$t('intervention.reported_problem')}}:</b>
                </div>
                <div class="col s10 input-field"><input :disabled="edit == false" v-model="intervention.about" /></div>
            </div>
            <div class="row" v-if="!edit">
                <div class="col s2 label leftalign">
                    <b>{{$t('intervention.reporter')}}:</b>
                </div>
                <div class="col s10 input-field" v-if="intervention.address != undefined">
                    {{intervention.address.name}} {{intervention.address.street}} {{intervention.address.postal_code}} {{intervention.address.city}}
                </div>
            </div>
            <div class="row" v-if="!edit">
                <div class="col s2 label leftalign">
                    <b>{{$t('intervention.address')}}:</b>
                </div>
                <div class="col s10 input-field" v-if="intervention.address2 != undefined">{{intervention.address2.street}} {{intervention.address2.flatno}} {{intervention.address2.postal_code}} {{intervention.address2.city}}</div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s2 label">
                    {{$t('intervention.type')}}:
                </div>
                <div class="col s2">
                    <label>
                        <input :disabled="edit == false" type="checkbox" v-model="intervention.types" value="deratization" />
                        <span> {{$t('intervention.deratization')}}</span>
                    </label>
                </div>
                <div class="col s2">
                    <label>
                        <input :disabled="edit == false" type="checkbox" v-model="intervention.types" value="disinsection" />
                        <span> {{$t('intervention.disinsection')}}</span>
                    </label>
                </div>
                <div class="col s2">
                    <label>
                        <input :disabled="edit == false" type="checkbox" v-model="intervention.types" value="disinfection" />
                        <span> {{$t('intervention.disinfection')}}</span>
                    </label>
                </div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s1 offset-s2">
                    <label>
                        <input :disabled="edit == false" type="checkbox" v-model="intervention.types" value="other" />
                        <span> {{$t('intervention.other')}}</span>
                    </label>
                </div>
                <div class="col s5 input-field" v-if="intervention.types.indexOf('other') != -1">
                    <input :disabled="edit == false" v-model="intervention.other_what" :placeholder="$t('intervention.other_type_placeholder')" />
                </div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s4 label rightalign input-field inline" style="overflow: auto">
                    <div style="float:left">{{$t('intervention.date')}}:</div>
                    <input type="datetime-local" name="meeting-time" v-model="intervention.date" style="float:left; width: 80%;" />
                </div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s4 label rightalign input-field inline" style="overflow: auto">
                    <div style="float:left">{{$t('intervention.street')}}.</div>
                    <input :disabled="edit == false" v-model="intervention.address2.street" v-if="!intervention.routine_service && intervention.address2 != undefined" style="float:left; width: 90%;" />
                    {{addressPlaceById(intervention.place_id).street}}
                </div>
                <div class="col s1 label rightalign input-field inline" style="overflow: auto">
                       <input :disabled="edit == false" v-model="intervention.address2.flatno" v-if="!intervention.routine_service && intervention.address2 != undefined" style="float:left; width: 90%;" />
                </div>
                <div class="col s1 label rightalign">
                    {{$t('intervention.city')}}
                </div>
                <div class="col s3 input-field label">
                    <input :disabled="edit == false" v-model="intervention.address2.city" v-if="!intervention.routine_service && intervention.address2 != undefined">
                    {{addressPlaceById(intervention.place_id).city}}
                </div>
                <div class="col s2 label rightalign">
                    {{$t('intervention.postalcode')}}
                </div>
                <div class="col s1 input-field label">
                    <input :disabled="edit == false" v-model="intervention.address2.postal_code" v-if="!intervention.routine_service && intervention.address2 != undefined">
                    {{addressPlaceById(intervention.place_id).postal_code}}
                </div>
            </div>
            <div class="row">
                <div class="col s2">
                    <b>{{$t('intervention.thingsdone')}}:</b>
                </div>
                
                <div class="row col s10" v-if="edit">
                    <div class="col s4" v-for="method in intervention_methods">
                        <label>
                            <input type="checkbox" v-on:change="changedInterventionMethod(method)" v-model="applied_methods_ids" :value="method.id"/>
                            <span>{{method.name}}</span>
                        </label>
                    </div>
                </div>
                <div class="row col s10" v-if="!edit">
                    <p>{{intervention.activities}}</p>
                    <template  v-for="im in intervention.applied_methods">
                        <p style="white-space: line-break;" class="appliedmethod">{{im.comment}}</p>
                    </template>
                    
                </div>
            </div>
            <div class="row">
                <div class="col s3">
                    <b>{{$t('intervention.dosages')}}:</b>
                </div>
                <div class="row col s9" v-if="!edit" >
                    <template v-for="dosage in intervention.dosages">
                        <div class="col s12 label" v-if='dosage.substance_name != null'>
                            
                            <substancepopup :substance="{'name': dosage.substance_name, 'id': dosage.substance_id }"/>
                        </div>
                        <div class="col s12 label" v-else>
                            <b>{{dosage.other_name}}</b>
                        </div>
                        <div class="col s12 label">
                            {{dosage.quantity}} {{units_dict[dosage.dosage_unit]}} 
                            <template v-if="dosage.solution_volume > 0">
                            preparatu na {{dosage.solution_volume}} {{units_dict[dosage.solution_unit]}} {{perunits_dict[dosage.solution_per_units]}}
                            </template>
                        </div>
                        <div class="col s12 label">
                            {{$t('intervention.total_applied')}}: {{dosage.dose}} {{units_dict[dosage.dosage_unit]}}
                        </div>
                        <div class="col s12 label">{{$t('intervention.where_applied')}}: {{dosage.placement}}</div>
                    </template>
                </div>
            </div>
            <template v-for="dosage in intervention.dosages">
                <interventiondosageedit  v-if="edit" :dosage="dosage" :substances="substances" v-on:removedosage="removeDosage"/>
            </template>
            <div class="row" v-if="edit">
                <div class="col s4">
                    <button class="btn green adder" v-on:click="addDosage()" v-if="edit">{{$t('intervention.add_dosage')}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col s3">
                    <b>{{$t('intervention.used_materials')}}:</b>
                </div>
                <div class="col s9 row">
                    <template v-for="material in intervention.materials" v-if="!edit">
                        <div class="col s12">
                            {{material.material_item_name != null ? material.material_item_name : material.name}}, {{material.quantity}} {{materialunits_dict[material.unit]}}
                        </div>
                        <div class="col s12">
                            {{$t('intervention.notices')}}: {{material.more}}
                        </div>
                    </template>
                </div>
            </div>
            <template v-for="material in intervention.materials" >
            <interventionmaterialedit v-if="edit" :material="material" :material_items="material_items" v-on:removematerial="removeMaterial"/>
            </template>
            <div class="row" v-if="edit">
                <div class="col s4">
                    <button class="btn green adder" v-on:click="addMaterial()" v-if="edit">{{$t('intervention.add_material')}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col s2 label" v-if="edit">
                    {{$t('intervention.protocol_sentence')}}:
                </div>
            </div>
            <div class="row inputframe" v-if="edit">
                <template v-for="im in intervention.applied_methods" v-if="im._destroy != true">
                    <div class="col s11 label input-field" >
                        <editable v-model="im.comment" :disabled="false" :striphtml="true"/>
                    </div>
                     <div class="col s1 label input-field">
                         <button class="removemethod" v-on:click="removeAppliedMethod(im)"><i class="material-icons">close</i></button>
                     </div>
                 </template>
            </div>
            <div class="row">
                <div class="col s2 label">
                    <b>{{$t('intervention.additional_notices')}}:</b>
                </div>
                <div class="col s10 row">
                    <div class="col offset-s1 s11">
                        <textarea v-model="intervention.description" v-if="edit"></textarea>
                        <template v-if="!edit">
                            {{intervention.description}}
                        </template>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="col s2 label">
                    <b>{{$t('intervention.recommendations')}}:</b>
                </div>
                <div class="col s10 row">
                <div class="col s12 label">
                    <p v-if="!edit && intervention.opened"> {{$t('intervention.opened_prefix')}} {{intervention.opened_after}} h. {{$t('intervention.opened_middle')}} {{$t('intervention.opened_suffix')}} {{intervention.ventillation_time}} h.</p>
                    <p v-if="!edit && intervention.ventillation"> {{$t('intervention.ventillate')}}</p>
                    <p v-if="!edit && intervention.ventillation"> {{$t('intervention.ventillate_suffix')}}</p>
                    <p v-if="!edit && intervention.exposition"> {{$t('intervention.exposition')}} {{intervention.exposition_time}} dni.</p>
                    <p v-if="!edit && intervention.contact_medic"> {{$t('intervention.contact_medic')}}</p>
                    <p v-if="!edit && intervention.other">{{intervention.other_recommendation}}</p>
                    <p v-if="edit">
                        <label class="input-field">
                            <input type="checkbox" name="closed" v-model="intervention.opened" />
                            <span>{{$t('intervention.opened_prefix')}}</span>
                            <input v-model="intervention.opened_after" type="text" name="" style="width: 7%;" /> <span>h.</span><br />
                            <span class="line">{{$t('intervention.opened_middle')}}</span>
                            </br>
                            <span class="line">{{$t('intervention.opened_suffix')}}</span>
                            <input type="text" name="" style="width: 7%;" v-model="intervention.ventillation_time" /> <span>h.</span>
                        </label>
                    </p>
                    <p v-if="edit">
                        <label class="input-field">
                            <input type="checkbox" name="ventillation" v-model="intervention.ventillation" />
                            <span>{{$t('intervention.ventillate')}}</br>
                                {{$t('intervention.ventillate_suffix')}}
                            </span>
                        </label>
                    </p>
                    <p v-if="edit">
                        <label class="input-field">
                            <input type="checkbox" name="not_touch" v-model="intervention.exposition" />
                            <span>{{$t('intervention.exposition')}}</span>
                            <input type="text" name="" style="width: 7%;" v-model="intervention.exposition_time" />
                            <span>dni.</span>
                        </label>
                    </p>
                    <p v-if="edit">
                        <label class="input-field">
                            <input type="checkbox" name="contact_medic" v-model="intervention.contact_medic" />
                            <span>{{$t('intervention.contact_medic')}}</span>
                        </label>
                    </p>
                    <p v-if="edit">
                        <label class="input-field">
                            <input type="checkbox" name="other" v-model="intervention.other" />
                            <span>{{$t('intervention.other')}}</span>
                            <input type="text" name="" style="width: 50%;" v-model="intervention.other_recommendation" />
                        </label>
                    </p>
                    <p v-for="other_reco in intervention.other_recommendations" v-if="!edit">
                        {{other_reco.text}}
                    </p>
                </div>
            </div>
            </div>

            <div class="row" v-if="edit">
                <div class="col s2">
                    {{$t('intervention.workers')}}:
                </div>
                <div class="col s2">
                    <selector v-model="intervention.worker_ids" :items="workers" identifier='workers' />
                </div>
            </div>
            <div class="row" v-if="!edit && intervention.announcements.length == 0">
                <div class="col s12 label"><b>{{$t('intervention.reporter_announcements')}}:</b></div>
                <div class="col s12 label">{{$t('intervention.safety_announcement', {"company_name": company_name})}} </div>
                <div class="col s12 label">{{$t('intervention.substances_announcement', {"www": www, "company_email": email})}} </div>
                <div class="col s12 label">{{$t('intervention.data_announcement')}}</div>
            </div>
            <div class="row" v-if="!edit && intervention.announcements.length > 0">
                <div class="col s12 label"><b>{{$t('intervention.reporter_announcements')}}:</b></div>
                <div class="col s12 label" v-for="anno in intervention.announcements">{{anno.text}}</div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s2 label">
                    {{$t('intervention.payment_document')}}:
                </div>
                <div class="col s2 label" v-if="edit">
                    <select v-model="intervention.payment_document">
                        <option v-for="payment_document in payment_documents" :value='payment_document.value'>{{payment_document.name}}</option>
                    </select>
                </div>
                <div class="col s2 label" v-if="!edit">
                    {{payment_labels[intervention.payment_document]}}
                </div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s2 label">{{$t('tasks.payment_method')}}</div>
                 <div class="col s1"><select v-model='intervention.payment_method' v-if="edit">
                        <option value="cash">{{$t('tasks.payment_methods.cash')}}</option>
                        <option value="transfer">{{$t('tasks.payment_methods.transfer')}}</option>
                        <option value="card">{{$t('tasks.payment_methods.card')}}</option>
                        <option value="blik">{{$t('tasks.payment_methods.blik')}}</option>
                    </select>
                    <template v-else>{{payment_methods[intervention.payment_method]}}</template>
                </div>
                 <div class="col s2 label">{{$t('tasks.pricing')}}</div>
                <div class="col s1 input-field"><input v-model="intervention.price" v-if="edit" /></div>
            </div>
            <div class="row" v-if="edit">
                <div class="col s1 label">{{$t('intervention.nip')}}</div>
                <div class="col s2 label  input-field"><input :disabled="edit == false" v-model="intervention.nip" /></div>
                <div class="col s1 label">{{$t('intervention.name')}}</div>
                <div class="col s2 label  input-field"><input :disabled="edit == false" v-model="intervention.invoice_address.name" /></div>
                <div class="col s1 label">{{$t('intervention.address')}}</div>
                <div class="col s2 label  input-field"><input :disabled="edit == false" v-model="intervention.invoice_address.street" /></div>
            </div>
            <div class="row" v-if="intervention.send_mail && !edit">
                <div class="col s12 label">
                    {{$t('intervention.mail_sent')}}: {{intervention.email}}
                </div>
            </div>
            <div class="row">
                <div class="col s3 label">
                    {{$t('intervention.protocol_created_by')}}:
                </div>
                <div class="col s3 label" v-if="!edit">
                    {{intervention.worker_name}}
                </div>
                <div class="col s3 label" v-if="edit">
                    <select v-model="intervention.worker_id">
                        <option v-for="worker in workers" :value='worker.value'>{{worker.name}}</option>
                    </select>
                </div>
                <div class="col s3 label">
                    {{$t('intervention.protocol_accepted_by')}}:
                </div>
                <div class="col s3 label" v-if="!edit">
                    {{intervention.acceptor}}
                </div>
                <div class="col s3 label input-field" v-if="edit">
                    <input :disabled="edit == false" v-model="intervention.acceptor" />
                </div>
            </div>
            <div class="row" v-if="!edit">
                <div class="col s6 label"><img :src="`data:image/png;base64,${intervention.worker_signature}`" v-if="intervention.worker_signature != undefined" style="max-width: 80%;"></div>
                <div class="col s6 label"><img :src="`data:image/png;base64,${intervention.signature_image}`" v-if="intervention.signature_image != undefined" style="max-width: 80%;"></div>
            </div>
            <template v-if="intervention.media.length > 0 || edit">
                <div class="row" style="margin-bottom: 64px !important;">
                    <div class="col s12 label">{{$t('intervention.photos')}}</div>      
                </div>
                 <div class="row">
                    <div class="col s2" v-for="(photo, index) in intervention.media" v-if="photo._destroy != true" style="width: fit-content;margin: auto;height: 100px;">
                        <button class="removephoto" v-on:click="removePhoto(photo)" v-if="edit"><i class="material-icons">close</i></button>
                        <div style="width: fit-content; margin: auto;">
                            <img :class="'photo'+index" style="max-height: 80px" v-if="photo.image == undefined"/>
                            <img :class="'photo'+index" style="max-height: 80px" :src="photo.uri"/>

                            <imagemagnify :image="photo.image"  v-if="photo.image && photo.image.thumb"/>
                            <imagemagnify :image="photo.uri"  v-if="photo.uri && photo.uri.thumb"/>
                        </div>
                          <input
                            v-if="photo.image == undefined && edit"
                            type="file"
                            id="photo"
                            name="photo"
                            multiple="true"
                            @change="setFile(photo, $event.target.name, $event.target.files)"
                            accept="image/png, image/jpeg"
                         />
                         

                    </div>
                </div>
                <div class="row" style="margin-bottom: 64px !important;">
                    <div class="col s3 offset-s6 label">
                        <a class="waves-effect waves-light btn-large cancelbutton" v-if="edit" v-on:click="addPhoto()">{{$t('menu.buttons.add_photo')}}</a>
                    </div>
                </div>
            </template>
        </div>
         <div v-if="!loaded && !error">
            <div class="container" style="width: 3%; margin: auto;">
                <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
        <div class="row" style="margin-bottom: 64px !important;">
            <div class="col s6 label">
            </div>
            <div class="col s3 label">
                <a class="waves-effect waves-light btn-large cancelbutton" v-if="edit" v-on:click="cancelChanges()">{{$t('menu.buttons.cancel_changes')}}</a>
            </div>
            <div class="col s3 label">
                <a class="waves-effect waves-light btn-large emptygreen" v-if="edit" v-on:click="saveChanges()">{{$t('menu.buttons.save_changes')}}</a>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Moment from 'moment';
export default {
    data: function() {
        return {
            error: false,
            intervention: {},
            intervention_methods: [],
            material_items: [],
            material_dict: {},
            substance_dict: {},
            payment_methods: {
                "cash": this.$t('tasks.payment_methods.cash'),
                "transfer": this.$t('tasks.payment_methods.transfer'),
                "card": this.$t('tasks.payment_methods.card'),
                "blik": this.$t('tasks.payment_methods.blik')
              },
            payment_documents: [
                { value: "invoice", name: this.$t('intervention.invoice') },
                { value: "receipt", name: this.$t('intervention.receipt') }
            ],
            materialunits_dict: {
                "grams": "gram",
                "meters": "m",
                "pieces": "szt",
                "packages": "opakowań"
            },
            units_dict: {
                "g": " g",
                "kg": " kg",
                "l": " l",
                "m2": " m2",
                "m3": " m3",
                "ml": " ml",
                "percent": " %",    
                "ppm": " ppm",
                "pieces": " szt",
                "pcs": " szt"
            },
            perunits_dict: {
                'mixture': this.$t('substances.per_whats.mixture'),
                'water': this.$t('substances.per_whats.water'),
                'point': this.$t('substances.per_whats.device'),
                'device': this.$t('substances.per_whats.device'),
                'surface': this.$t('substances.per_whats.surface'),
                'room': this.$t('substances.per_whats.room')
            },
            announcements: [],
            substances: [],
            customers: [],
            workers: [],
            loaded: false,
            customers_loaded: false,
            edit: false,
            signatures: {},
            place_indexes: {},
            labels: {},
            payment_labels: {},
            question: this.$t('menu.save_question'),
            confirmText: "",
            cancelText: "",
            instances: null,
            callback: null
        };
    },
    beforeRouteLeave (to, from , next) {
      if(this.edit){
          this.question = this.$t('menu.save_question');
          this.cancelText = this.$t('menu.buttons.save_cancel')
          this.confirmText = this.$t('menu.buttons.save_changes')
          this.instances[0].open();
          this.callback = next;
      }else{
        next()
      }      
    },
    mounted(){
      var elems = this.$el.querySelectorAll('.modal');
      this.instances = M.Modal.init(elems, {});
    },
    props: {company_name: String, company_address: Object, www: String, email: String},
    async created() {
        if (this.$route.params.intervention_id != 'new') {
            try { 
                var response = await axios.get('/interventions/' + this.$route.params.intervention_id + '.json')
                this.intervention = response.data;
                this.intervention.date = Moment(this.intervention.date).utcOffset(0, true).format('YYYY-MM-DDTHH:mm')
                this.intervention.address2 ||= {}
                this.intervention.invoice_address ||= {}
                this.intervention.payment_method ||= "cash"
                this.intervention.price ||= 0
                document.title = "Protokół zabiegu interwencyjnego "+this.intervention.number;
            }catch(error) {
                this.error = true;
                console.log('Caught!', error);
                this.loaded = true;
            }
        } else {
            this.edit = true;
            this.intervention = {
                editable: true,
                types: [],
                address: {

                },
                address2: {

                },
                invoice_address: {

                },
                applied_methods: [],
                intervention_method_ids: [],
                dosages: [],
                materials: [],
                media: [],
                payment_method: "cash",
                price: 0,
                date: Moment().utcOffset(0, true).format('YYYY-MM-DDTHH:mm')
            };
        }
        this.loaded = true;
        var that = this;
        this.labels = _.fromPairs(_.map(that.payment_methods, _.values));
        this.payment_labels = _.fromPairs(_.map(that.payment_documents, _.values));
        if(this.intervention.editable){
            var response = await axios.get('/intervention_methods.json');
            this.intervention_methods = response.data;
            var response = await axios.get('/substances.json');
            this.substances = response.data;
            var response = await axios.get('/workers.json');
            this.signatures = {}
            
            this.workers = response.data.map(function(worker) {
                return { name: worker.name + " " + worker.surname, value: worker.id, active: worker.active };
            }).filter(function(worker) {
                return worker.active;
            })
            var response = await axios.get('/material_items.json');
            this.material_items = response.data;
            this.material_dict = _.keyBy(that.material_items, 'id');
            this.substance_dict = _.keyBy(that.substances, 'id');
            this.method_dict = _.keyBy(that.intervention_methods, 'id');
            var response = await axios.get('/customers.json');
            this.customers = response.data;
            for (var customer in this.customers) {
                for (var place in this.customers[customer].places) {
                    this.place_indexes[this.customers[customer].places[place].id] = { name: this.customers[customer].name, address: this.customers[customer].places[place].address }
                }

            }
           
            this.customers_loaded = true;
            this.$forceUpdate();
        }
    },
    computed: {
        applied_methods_ids: {
            get: function() {
                return _.map(_.filter(this.intervention.applied_methods, function(appmet){
                    return appmet._destroy != true
                }), "intervention_method_id");
            },
            set: function(newValue) {

            }
        },
        customerItems: {
            get: function() {
                var output = [];
                for (const customer of this.customers) {
                    if (customer.status == "active") {
                        var places = customer.places.filter((place) => place.status == "active");
                        if (places.length > 0) {
                            output.push({ "id": customer.id, "name": customer.name, "places": places });
                        }
                    }
                }
                return output;
            }
        }
    },
    methods: {
        addDosage() {
            this.intervention.dosages.push({ dosage_unit: 'g' })
        },
        removeDosage(dosage) {
            if (_.isUndefined(dosage.id)) {
                this.intervention.dosages.splice(this.intervention.dosages.indexOf(dosage), 1);
            } else {
                dosage.destroy = true;
                this.$forceUpdate();
            }
        },
        removeMaterial(material) {
            if (_.isUndefined(material.id)) {
                this.intervention.materials.splice(this.intervention.materials.indexOf(material), 1);
            } else {
                material.destroy = true;
                this.$forceUpdate();
            }
        },
        okClicked(){
            this.saveChanges()
        },
        cancelClicked(){
            this.callback();
        },
        addMaterial() {
            this.intervention.materials.push({ material_item_id: undefined, unit: 'pieces' })
        },
        placeById(place_id) {
            if (_.isUndefined(this.place_indexes[place_id]) == false) return this.place_indexes[place_id].name
        },
        addressPlaceById(place_id) {
            if (_.isUndefined(this.place_indexes[place_id]) == false) return this.place_indexes[place_id].address
            else return {}
        },
        toggleEdit() {
            this.edit = true
        },
        changedInterventionMethod(im) {
            var found = _.find(this.intervention.applied_methods, { intervention_method_id: im.id });
            if (found) this.intervention.applied_methods.splice(this.intervention.applied_methods.indexOf(found), 1)
            else this.intervention.applied_methods.push({ intervention_method_id: im.id, comment: im.description });
        },
        deleteProtocol() {
            var that = this;
            if (confirm(this.$t('intervention.remove_question'))) {
                axios.delete('/interventions/' + this.intervention.id + '.json').then(function() {
                    that.$router.push({ name: 'interventions' })
                })
            }
        },
        cancelChanges() {
            this.edit = false;
            if (confirm(this.$t('intervention.change_question'))) {
                if (this.intervention.id) {
                    this.edit = false;
                }else{
                     this.$router.push({ name: 'interventions' })
                }
               
            }
        },
        toFormData(formData, prefix, obj) {
            if (_.isUndefined(obj) == false && _.isNull(obj) == false) {
                for (var key of Object.keys(obj)) {
                    if (_.isString(obj[key]) || _.isNumber(obj[key]) || _.isBoolean(obj[key])) formData.append(prefix + '[' + key + ']', obj[key]);
                    else if (_.isArray(obj[key])) {
                        for (var c of Object.keys(obj[key])) {
                            if (_.isString(obj[key][c]) || _.isNumber(obj[key][c])) formData.append(prefix + '[' + key + '][]', obj[key][c]);
                            else if (_.isObject(obj[key][c])) this.toFormData(formData, prefix + '[' + key + '_attributes][' + c + ']', obj[key][c]);
                        }
                    } else if (obj[key] instanceof File){
                        formData.append('' + prefix + '[' + key + ']', obj[key], obj[key].name)
                    } else if (_.isObject(obj[key])) this.toFormData(formData, '' + prefix + '[' + key + '_attributes]', obj[key])
                }
            }
        },
        addPhoto: function(){
            this.intervention.media.push({notices: "",uri: undefined});
            this.$forceUpdate();
        },
        removePhoto(photo) {
            if (_.isUndefined(photo.id)) {
                this.intervention.media.splice(this.intervention.media.indexOf(photo), 1)
            } else {
                photo._destroy = true;
            }
             this.$forceUpdate();
        },
        removeAppliedMethod(appliedmethod){
            if (_.isUndefined(appliedmethod.id)) {
                 this.intervention.applied_methods.splice(this.intervention.applied_methods.indexOf(appliedmethod), 1)
            }else{
                appliedmethod._destroy = true;
                  this.$forceUpdate();
            }
        },
        setFile: function(doc, name, file) {
            var that = this;

            doc.image = file[0];
            var reader = new FileReader();

            reader.onload = function(event) {
                var dataUri = event.target.result;
                doc.uri = dataUri;
                // img.src = dataUri;
            };
            reader.onerror = function(event) {
            };
            reader.readAsDataURL(doc.image);
            if (file.length > 1) {
                for (var i in _.range(file.length)) {
                    if (i > 0) {
                        var ndoc = { timestamp: _.now(), uri: undefined, image: undefined };
                        ndoc.image = file[i];
                        var reader = new FileReader();

                        reader.onload = function(event) {
                            var dataUri = event.target.result;
                            ndoc.uri = dataUri;
                        };
                        reader.onerror = function(event) {
                        };
                        reader.readAsDataURL(ndoc.image);

                        this.intervention.media.push(ndoc)
                    }
                }
            }

        },
        saveChanges() {
            var that = this;
            const formData = new FormData();
            this.toFormData(formData, 'intervention', this.intervention)
            if (this.intervention.id) {
                axios.put('/interventions/' + this.intervention.id + '.json', formData).then(function() {
                    that.edit = false;
                    that.$router.push({ name: 'interventions' })
                });
            } else {
                axios.post('/interventions.json', formData).then(function() {
                    that.edit = false;
                    that.$router.push({ name: 'interventions' })
                });
            }
        }
    }
}
</script>
<style scoped>
#removeConfirm{
  right: 0% !important;
}
.row {
    margin-bottom: 20px !important;
}

/deep/ select {
    display: block;
    border-radius: 4px;
    border-color: rgb(140, 140, 140) !important;
    height: 2.5rem;
}

.leftalign {
    text-align: left;
}

.rightalign {
    text-align: right;
}

.label {
    line-height: 2.5;
}

.upper {
    text-transform: uppercase;
}

label span {
    font-size: 0.9rem !important;
}

label span.line {
    padding-left: 35px;
}

label input {
    margin-left: 5px !important;
}

.inputframe {
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    min-height: 32px;
}

.inputframe input {
    margin-top: 8px;
}

.btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 36px;
    line-height: 36px;
}

div[editing] b {
    font-weight: normal !important;
}

.adder {
    border-radius: 5px;
    color: black;
}

.solidred {
    border-radius: 5px;
    color: black;
    background-color: #c22026;
    border-color: #c22026;
}
.removephoto {
    vertical-align: top;
    float: right;
    background-color: black;
    border: none;
    border-radius: 15px;
}
.removephoto i {
    color: white;
}
.appliedmethod{
    white-space: break-spaces;
}
@media only screen {
    .interventionprotocol {
        border: 1px solid;
        margin: 75px;
        padding: 15px;
    }
}
@media only print {
    .interventionprotocol {
        font-size: 13px;
    }
}
</style>
